import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

const PostItem = props => {
  const { postTitle, postDate, postUrl } = props;

  return (
    <div>
      <Link to={postUrl}>{postTitle}</Link>
      <div>{postDate}</div>
    </div>
  );
};

PostItem.propTypes = {
  postTitle: PropTypes.string.isRequired,
  postDate: PropTypes.string.isRequired,
  postUrl: PropTypes.string.isRequired,
};

export default PostItem;



// WEBPACK FOOTER //
// ./src/components/PostItem.js